import { View } from 'components/View/View'
import React, { useRef, useMemo, useState, useCallback, ReactElement, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import css from './HomePage.module.css'
import RFB from 'modules/novnc/core/rfb'
import { APIRequest } from '@lynx/client-core/src/api'
import * as qs from 'query-string'
import { Logger } from '@lynx/client-core/src/modules/Logger'
import { Alert } from '@lynx/client-core/src/components'

export const HomePage = (): ReactElement => {
	const location = useLocation()
	const screenRef = useRef<HTMLDivElement>(null)
	const connectionTries = useRef(0)
	const query = useMemo(() => qs.parse(location.search), [location.search])
	const [, setRfb] = useState<RFB | undefined>(undefined)
	const [connected, setConnected] = useState(false)
	const [error, setError] = useState<string | undefined>(undefined)

	const makeVNCConnection = useCallback(async (fileName: string, userId: string, url: string) => {
		try {
			connectionTries.current++
			const rfb: RFB = new RFB(screenRef.current, `wss://${url}`, {
				credentials: { password: 'password' }
			})
			rfb.scaleViewport = true
			rfb.clipViewport = true
			rfb.resizeSession = true
			rfb.viewOnly = false
			rfb.showDotCursor = true

			rfb.addEventListener('disconnect', async () => {
				Logger.log('Not Connected')
				setConnected(false)
				setTimeout(() => {
					Logger.log('Retry...')
					connectionTries.current++
					makeVNCConnection(fileName, userId, url)
				}, 3000)
			})

			rfb.addEventListener('connect', async () => {
				Logger.log('Connected')
				setRfb(rfb)
				setConnected(true)
			})
		} catch (err) {
			Logger.error(err)
			if (err instanceof Error) setError(err.message)
		}
	}, [])

	const initialize = async (): Promise<void> => {
		try {
			const { fileName, userId } = query
			if (!fileName || typeof fileName !== 'string' || !userId || typeof userId !== 'string') {
				setError('Incorrect types in query params.')
				return
			}

			const result = await APIRequest.Translator.apply(fileName, userId)
			await makeVNCConnection(fileName, userId, result.domain)
		} catch (err) {
			if (err instanceof Error) setError(err.message)
			Logger.error(err)
		}
	}

	useEffect(() => {
		initialize()
	}, [query, makeVNCConnection])

	const deletePod = useCallback(async (): Promise<boolean> => {
		const { fileName } = query
		Logger.log(fileName)
		await APIRequest.Translator.delete(fileName as string)
		window.close()
		return true
	}, [query])

	return (
		<div className={css.container}>
			<div className={css.body}>
				{!connected && (
					<div className={css.loadingContainer}>
						<div className={css.animateFlicker}>
							<img alt="Lynx Logo" src="/lynx-whiteboard-logo.svg" />
							<p>Loading...</p>
						</div>
						<div className={css.errorContainer}>{error && <Alert styleClass="danger">{error}</Alert>}</div>
					</div>
				)}
				{connected && (
					<div>
						<button className={css.closeButton} onClick={deletePod}>
							CLOSE
						</button>
					</div>
				)}
				<View>
					<div ref={screenRef} style={{ width: '100%', height: '100%' }} />
				</View>
			</div>
		</div>
	)
}
